import { triplaServer } from 'src/apis/server'

export default {
  getTermsConditions(hotelCode) {
    return triplaServer
      .get(`hotels/${hotelCode}/settings/terms_and_conditions`)
      .then((res) => res.data)
  }
}
